import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { LinkedCard } from '../provider/service/fidel/models/linkedcard.model';

export interface CardLinkingState extends EntityState<LinkedCard> {}

@Injectable({ providedIn: 'root' }) // becasue its services so we need
@StoreConfig({ name: 'card-linking', idKey: 'ExternalCardId' }) // Meta Data of store
export class CardLinkingStore extends EntityStore<CardLinkingState> {
  constructor() {
    super();
  }
}
